import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
import { saveAs } from 'file-saver'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 获取表头
export const getWebTitleColumnResultList = (data?: any) =>
  request.post('/paas/page/webTitleColumnResultList', data, jsonHeaderConfig)
// 获取所有表头
export const getWebTitleColumnList = (data?: any) =>
  request.post('/paas/page/webTitleColumnList', data, jsonHeaderConfig)

// 获取快捷筛选
export const getWebSearchColumnResultList = (data?: any) =>
  request.post('/paas/page/webSearchColumnResultList', data, jsonHeaderConfig)
// 获取所有快捷搜索字段
export const getWebSearchColumnList = (data?: any) =>
  request.post('/paas/page/webSearchColumnList', data, jsonHeaderConfig)
export const getEchoAcquire = (data?: any) =>
  request.post('/component/echoAcquire', data, jsonHeaderConfig)
export const getQuoteValue = (data?: any) =>
  request.post('/crm/component/unionValue', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
export const getDetaultValue = (data?: any) =>
  request.post('/crm/component/defaultValue', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

// 获取布局1
export const getPositions = (data?: any) =>
  request.post('/paas/config/position', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

export const getPositionList = (data?: any) =>
  request.post('/paas/config/position', data, jsonHeaderConfig)

// 保存新增布局
export const savePositionList = (data?: any) =>
  request.post('/paas/config/updateAddPosition', data, jsonHeaderConfig)
// 保存详情布局
export const saveDetailPositionList = (data?: any) =>
  request.post('/paas/config/updateDetailPosition', data, jsonHeaderConfig)
// 获取预定义应用列表
export const getPassTableList = (data?: any) =>
  request.post('/paas/config/applicationList', data, jsonHeaderConfig)

// 查询应用详情
export const getAppDetails = (data?: any) =>
  request.post('/paas/config/appDetails', data, jsonHeaderConfig)

// 应用批量删除
export const appDeleter = (data?: any) =>
  request.post('/paas/app/appDeleter', data, jsonHeaderConfig)

// 获取表单布局字段信息
export const getPositionColumnList = (data?: any) =>
  request.post('/paas/config/getModuleColumnList', data, jsonHeaderConfig)

// 获取表单公共字段信息
export const getTableColumnList = (data?: any) =>
  request.post('/paas/config/tableColumnList', data, jsonHeaderConfig)

// 获取表单公共字段信息
export const getUnionTableList = (data?: any) =>
  request.post('/paas/config/unionTableList', data, jsonHeaderConfig)

// 获取表单关联字段信息
export const getQuoteTableList = (data?: any) =>
  request.post('/paas/config/quoteTableList', data, jsonHeaderConfig)

// 获取子系统下拉
export const getSystemEnableList = (data?: any) =>
  request.post('/paas/app/systemList', data, jsonHeaderConfig)

// 新增应用包
export const addApplicationPackage = (data?: any) =>
  request.post('/paas/package/addApplicationPackage', data, jsonHeaderConfig)
// 编辑应用包
export const updateApplicationPackage = (data?: any) =>
  request.post('/paas/package/updateApplicationPackage', data, jsonHeaderConfig)
// 新增应用
export const appCreator = (data?: any) =>
  request.post('/paas/config/appCreator', data, jsonHeaderConfig)
// 修改应用属性
export const appUpdater = (data?: any) =>
  request.post('/paas/config/appUpdater', data, jsonHeaderConfig)

// 获取关联表单列表
export const getAlreadyTableList = (data?: any) =>
  request.post('/paas/config/alreadyTableList', data, jsonHeaderConfig)

// 获取无归属字段
export const getNonModuleComponentList = (data?: any) =>
  request.post('/paas/config/getNonModuleComponentList', data, jsonHeaderConfig)

// 获取表单展示字段
export const getTableTitleColumnList = (data?: any) =>
  request.post('/paas/page/tableTitleColumnList', data, jsonHeaderConfig)

// 获取表单展示字段
export const getAdminTitleColumnList = (data?: any) =>
  request.post('/paas/page/webTitleColumnList', data, jsonHeaderConfig)

// 表单展示字段修改
export const tableTitleColumnUpdater = (data?: any) =>
  request.post('/paas/page/tableTitleColumnUpdater', data, jsonHeaderConfig)

// 获取已排序字段
export const getTableRankColumnList = (data?: any) =>
  request.post('/paas/page/getTableRankColumnList', data, jsonHeaderConfig)

// 获取能排序的字段
export const getAdminRankColumnList = (data?: any) =>
  request.post('/paas/page/rankColumnList', data, jsonHeaderConfig)

// 修改排序
export const tableRankColumnUpdater = (data?: any) =>
  request.post('/paas/page/tableRankColumnUpdater', data, jsonHeaderConfig)

// 获取已选择快捷搜索
export const getTableSearchColumnList = (data?: any) =>
  request.post('/paas/page/getTableSearchColumnList', data, jsonHeaderConfig)
// 获取所有快捷搜索
export const getAdminSearchColumnList = (data?: any) =>
  request.post('/paas/page/webSearchColumnList', data, jsonHeaderConfig)
// 修改搜索
export const tableSearchColumnUpdater = (data?: any) =>
  request.post('/paas/page/tableSearchColumnUpdater', data, jsonHeaderConfig)

// 获取表单按钮信息
export const getTableButtonList = (data?: any) =>
  request.post('/paas/config/tableButtonList', data, jsonHeaderConfig)

// 保存按钮
export const saveTableButton = (data?: any) =>
  request.post('/paas/config/saveTableButton', data, jsonHeaderConfig)

// 获取表单默认流程筛选配置
export const getDefaultProcessStateFilter = (data?: any) =>
  request.post('/paas/config/defaultProcessStateFilter', data, jsonHeaderConfig)

// 更新表单默认流程筛选配置
export const updateDefaultProcessStateFilter = (data?: any) =>
  request.post('/paas/config/defaultProcessStateFilter/update', data, jsonHeaderConfig)

// 编辑应用属性
export const saveAppOperate = (data?: any) =>
  request.post('/paas/config/appOperate', data, jsonHeaderConfig)

// 获取表单数据权限判定字段
export const tableBasicColumnList = (data?: any) =>
  request.post('/paas/config/tableBasicColumnList', data, jsonHeaderConfig)

// 获取表单数据权限判定字段回显
export const tableAuthColumnList = (data?: any) =>
  request.post('/paas/config/tableAuthColumnList', data, jsonHeaderConfig)

// 应用包详情信息
export const getPackageDetailById = (data?: any) =>
  request.post('/paas/package/detailById', data, jsonHeaderConfig)

// 禁用子系统
export const disableOrEnableSys = (data?: any) =>
  request.post('/paas/system/disableOrEnable', data, jsonHeaderConfig)

// 获取应用下拉列表
export const getApplicationList = (data?: any) =>
  request.post('/paas/package/getApplicationList', data, jsonHeaderConfig)

// 获取所有状态的应用 （启用禁用草稿）
export const getAllAppList = (data?: any) =>
  request.post('/paas/config/appList', data, jsonHeaderConfig)

// 应用包删除关联应用
export const deleteRefApplication = (data?: any) =>
  request.post('/paas/package/deleteRefApplication', data, jsonHeaderConfig)

// 应用包关联应用
export const addRefApplication = (data?: any) =>
  request.post('/paas/package/addRefApplication', data, jsonHeaderConfig)

// 获取该应用下所有字段
export const getTableColumnInfoList = (data?: any) =>
  request.post('/paas/package/getTableColumnInfoList', data, jsonHeaderConfig)

// 获取应用包关联资源
export const getSource = (data?: any) =>
  request.post('/paas/package/getSource', data, jsonHeaderConfig)

// 获取该应用下所有按钮
export const tableSceneTypeButtonList = (data?: any) =>
  request.post('/paas/package/tableSceneTypeButtonList', data, jsonHeaderConfig)

// 保存应用包关联资源
export const saveSource = (data?: any) =>
  request.post('/paas/package/saveSource', data, jsonHeaderConfig)

// 应用包禁用或启用
export const disableOrEnable = (data?: any) =>
  request.post('/paas/package/disableOrEnable', data, jsonHeaderConfig)

// 应用禁用或启用
export const applyDisableOrEnable = (data?: any) =>
  request.post('/paas/config/disableOrEnable', data, jsonHeaderConfig)

// 获取常用筛选
export const getSearchTemplate = (data?: any) =>
  request.post('/paas/searchTemplate/list', data, jsonHeaderConfig)
// 新建常用筛选
export const addSearchTemplate = (data?: any) =>
  request.post('/paas/searchTemplate/creator', data, jsonHeaderConfig)

// 删除
export const deleteTemplate = (data?: any) =>
  request.post('/paas/searchTemplate/deleter', data, jsonHeaderConfig)
// 获取搜索模板条件
export const getTemplateConditions = ({ tmpSerial }: Recordable) =>
  request.post(`/paas/searchTemplate/conditions/${tmpSerial}`, {}, jsonHeaderConfig)

// 编辑常用筛选
export const editSearchTemplate = (data?: any) =>
  request.post('/paas/searchTemplate/updater', data, jsonHeaderConfig)

// 自定义应用新增
export const crudInsert = (data?: any) => request.post('/crm/crud/insert', data, jsonHeaderConfig)

// 自定义应用列表数据
export const crudPage = (data?: any) => request.post('/paas/crud/page', data, jsonHeaderConfig)
export const crudPageCrm = (data?: any, headers?: any) =>
  request.post(
    '/crm/crud/page',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig
  )
// 删除自定义应用列表数据
export const crudDelete = (data?: any) => request.post('/paas/crud/delete', data, jsonHeaderConfig)

// 批量删除自定义应用列表数据
export const crudBatchDelete = (data?: any) =>
  request.post('/paas/crud/batchDelete', data, jsonHeaderConfig)
// 自定义编辑
export const crudUpdate = (data?: any) => request.post('/crm/crud/update', data, jsonHeaderConfig)
export const crudUpdateFromPaas = (data?: any) =>
  request.post('/paas/crud/update', data, jsonHeaderConfig)

// 自定义获取分栏数据
export const crudGroup = (data?: any) => request.post('/crm/crud/group', data, jsonHeaderConfig)
// 自定义获取分栏数据,获取paas服务的
export const crudGroupFromPass = (data?: any) =>
  request.post('/paas/crud/group', data, jsonHeaderConfig)

// 自定义获取子表数据
export const crudSublist = (data?: any) =>
  request.post('/crm/crud/sublist', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

export const crudSublistFromPaas = (data?: any) =>
  request.post('/paas/crud/sublist', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
// 获取导出列表
export const getGlobalExportList = (data?: any) =>
  request.post('/crm/exportCenter/taskList', data, jsonHeaderConfig)
// 删除导入数据
export const deleteExport = ({ id }: Recordable) =>
  request.post(`/crm/exportCenter/delete/${id}`, {}, jsonHeaderConfig)

export function exportMainApi(data: Recordable) {
  return request.post('/crm-report/exportCenter/start', data, jsonHeaderConfig)
}
// 下载导出文件
export const downloadExportFileApi = ({ id }: Recordable) => {
  return request
    .post(
      `/crm-report/exportCenter/download/${id}`,
      {},
      {
        responseType: 'blob'
      }
    )
    .then(res => {
      const blob = new Blob([res.data])
      const name = res.filename
        ? res.filename
        : new Date().getTime() + '_' + parseInt(Math.random() * 10000) + '.xlsx'
      console.log(name, 'name111')
      saveAs(blob, name)
    })
}

// 获取关联表单数据
export const getUnionTableDataList = (data?: any) =>
  request.post('/crm/component/unionTableDataList', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

// 删除字段的判断
export const tableColumnHasOccupy = (data?: any) =>
  request.post('/paas/config/tableColumnHasOccupy', data, jsonHeaderConfig)

// 获取弹窗字段
export const tableDialogTitleColumnList = (data?: any) =>
  request.post('/paas/page/tableDialogTitleColumnList', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

// 根据序列号获取columnInfo
export const getEnablePositionColumnListApi = (data?: any) =>
  request.post('/paas/config/getEnablePositionColumnList', data, jsonHeaderConfig)

// 表单提交校验
export const tableSubmitVerifyApi = (data?: any) =>
  request.post('/crm/component/tableSubmitVerify', data, jsonHeaderConfig)

// erp查询可配置流程的固定型应用
export const getErpAppList = (data?: any) =>
  request.post('/paas/app/page/fixed', data, jsonHeaderConfig)

//发起签约
export const initiateSign = (data?: any) =>
  request.post('/crm/contract/sign/initiate', data, jsonHeaderConfig)

export const getLocation = (data?: any) => request.get('/crm/track/facade/order/location', data)
